import { useState } from 'react'
import { Button } from 'components'
import { CreateDefaultLayoutsForProductModal } from './CreateDefaultLayoutsForProductModal'

type ShowState = [boolean, (value: boolean) => void]

/** Launch-dashboard entry point for the "Create default layouts for product" admin action. */
export const CreateDefaultLayoutsForProductButton = () => {
  const [show, setShow] = useState(false)

  return (
    <>
      <Button primary onClick={() => setShow(true)}>
        📐 Create default layouts for product
      </Button>
      <CreateDefaultLayoutsForProductModal
        show={[show, setShow] as ShowState}
      />
    </>
  )
}

export default CreateDefaultLayoutsForProductButton
